import React, { Component } from "react";
import { observer } from "mobx-react";
import { Accessor, ColorX, GFunc, GState, LocaleX, NavX, ResponsiveX, ZValidate } from "IZOX/STATIC";
// eslint-disable-next-line no-unused-vars
import PropsType from "prop-types";
import { HStack, VStack, XButton, XImage, XText } from "IZOX/_X";
import ReCAPTCHA from "react-google-recaptcha";
import { APIKeys } from "__SYSDefault/APIKeys";
import APIExpress from "__SYSDefault/APIs/APIExpress";
import { QForm } from "IZOX/BLOCKS/Libs";
import { QFDigitBox, QFPassword, QFText } from "IZOX/BLOCKS/Libs/QForm/_gears";
import Styles from "__SYSDefault/Styles";
import _ from "lodash";
import { withRouter } from "react-router-dom/cjs/react-router-dom";
import CountDownLite from "IZOX/BLOCKS/Libs/RefreshTimeCount/CountDownLite";
import { v1 } from "uuid";
import FooterM from "shared/FooterM";
import { SysConfig } from "__SYSDefault/Config";

/**
 * @augments {Component<Props, State>}
 */
class PLogin extends Component {

  static propTypes = {

  }

  static defaultProps = {

  }

  constructor(){
    super();
    this.state = {
      step: "emailPassword",
      // step: "OTP",
      reCAPTCHAvalid: false,
      epFormValid: false,
      formData: {},
      canResend: false,
      OTPFormID: v1()
    };
  }

  componentDidMount(){
    this._setAllStates(() => {
      window.addEventListener("keydown", this.onEnterKeyDown);
    });
  }

  componentDidUpdate(prevProps, prevState){
    if(!Accessor.IsIdentical(prevProps, this.props, Object.keys(PLogin.defaultProps))){
      this._setAllStates();
    }
  }

  componentWillUnmount() {
    window.removeEventListener("keydown", this.onEnterKeyDown);
    this.setState = (state, callback) => {
      return;
    };
  }

  _setAllStates = (callback) => {
    this.setState((state, props) => ({
      ...props,
    }), callback);
  }

  onMountCountDown = (callbacks) => {
    this.MountCountDown = callbacks;
  }

  onMountQFEmailPassword = (callbacks) => {
    this.MountQFEmailPassword = callbacks;
  }

  onMountQFOTP = (callbacks) => {
    this.MountQFOTP = callbacks;
  }

  onEnterKeyDown = (e) => {
    let {epFormValid} = this.state;
    if(e.key !== "Enter") return;
    if(!epFormValid) return;
    this._login();
  }

  _toStep = (step) => {
    this.setState({
      step: step
    });
  }

  _toForgotPassword = () => {
    let {history} = this.props;
    NavX.Goto(history, "/ForgotPassword");
  }

  _toRegister = () => {
    let {history} = this.props;
    GState.UPDATE("registerStep", "userType");
    GState.UPDATE("registerFormData", {
      userType: "Agent"
    });
    NavX.Goto(history, "/Register");
  }

  _onReCaptchaChange = async (token ) => {
    let res = await APIExpress.Login.ReCAPTCHA(token);
    this._updateFormData({
      reCAPTCHA: res.Success
    }, () => {
      let {formData} = this.state;
      let {Success, error} = this._checkEPFormValid(formData);
      this.setState({
        epFormValid: Success,
        error: error
      });
    });
  }

  _updateFormData = (formValue, callback = null) => {
    let {formData} = this.state;
    let newFormData = {
     ...formData,
     ...formValue
    };
    this.setState({
      formData: newFormData
    }, callback);
    return newFormData;
  }

  _checkEPFormValid = (formValue) => {    
    if(!ZValidate.CheckAllFields(formValue, ["email", "password"], ["required"])) {
      return {
        Success: false,
        error: {
          EN: "Some fields are empty.",
          TC: "有些欄位沒有填妥"
        }
      };
    }else if(Accessor.Get(formValue, "reCAPTCHA") !== true) {
      // return {
      //   Success: false,
      //   error: {
      //     EN: "Please check the reCAPTCHA box",
      //     TC: "請勾選reCAPTCHA方格"
      //   }
      // };
    }
    return {
      Success: true
    };
  }

  _login = async () => {
    let {history} = this.props;
    let {formData} = this.state;
    let {Success, error} = this._checkEPFormValid(formData);
    if(error) GFunc.Alert(error, "error");
    if(!Success) return;
    
    let res = await APIExpress.Login.SignIn(formData);
    if(!res.Success){
      GFunc.Alert(res.payload?.message, "error");
      return;
    }
    let {requireOTP, userID, requestID} = res.payload;
    if(requireOTP){
      this._updateFormData({
        userID: userID,
        requestID: requestID
      });
      this._toStep("OTP");
    }else{
      let logged = GFunc.Login(res.payload);
      if(logged.Success){
        NavX.Goto(history, "/User/Redirect");
      }
    }
    
  }

  _autoVerifyOTP = async (otp) => {
    let { history } = this.props;
    let { formData } = this.state;

    let userID = Accessor.Get(formData, "userID");
    let requestID = Accessor.Get(formData, "requestID");
    let email = Accessor.Get(formData, "email");
    let password = Accessor.Get(formData, "password");

    let res = await APIExpress.OTP.Verify(userID, requestID, "SignIn", otp);
    let {Success, payload} = res;

    if(Success){
      let authCode = payload;
      let authRes = await APIExpress.AuthCode.Authorize(authCode, email, password);

      let logged = GFunc.Login(authRes.payload);
      if(logged.Success){
        NavX.Goto(history, "/User/Redirect");
      }
    }else{
      this.MountQFOTP?.Clear?.();
      this.setState({
        OTPFormID: v1()
      });
    }
  }

  _canResend = () => {
    this.setState({
      canResend: true
    });
  }

  _resendOTP = async () => {
    let { formData } = this.state;
    let userID = Accessor.Get(formData, "userID");
    let res = await APIExpress.OTP.Resend(userID, "SignIn");
    let {Success, payload} = res;
    if(!Success){
      return;
    }

    this.MountCountDown?.Reset?.();
    this.setState({
      canResend: false
    });
    
    let { requestID } = payload;
    this._updateFormData({
      requestID: requestID
    });
  }

  renderEmailPassword(){
    let {epFormValid, error} = this.state;
    return (
      <QForm maxWidth={"80%"} width={416} fullHeight VAlign="^" pT={30}
        spacing={16} onMounted={this.onMountQFEmailPassword}
        onValidateReady={this.onValidateReady}
        onChange={(formValue) => {
          let _new = this._updateFormData(formValue);
          let {Success, error} = this._checkEPFormValid(_new);
          this.setState({
            formValue: formValue,
            epFormValid: Success,
            error: error
          });
        }}>
        <XImage source="/Images/home/logoV.png"/>
        <XText fontSize={32} color={ColorX.CSS("pureWhite")} bold>
          {LocaleX.Parse({
            EN: "Log In",
            TC: "登入"
          })}
        </XText>
        <VStack fullWidth>
          <HStack HAlign="[" spacing={5}>
            <XText fontSize={12} color={ColorX.CSS("Stone")}>
              {LocaleX.Parse({
                EN: "Login Username",
                TC: "登入用戶名"
              })}
            </XText>
            <XText fontSize={12} color={ColorX.CSS("Blood")}>
              {"*"}
            </XText>
          </HStack>
          <QFText
            emailOnly
            name="email"
            fontSize={14}
            p={12}
            bColor={ColorX.CSS("NotQuiteWhite")}
            placeholder={LocaleX.Parse({
              EN: "Please enter your Login Username here.",
              TC: "請在此輸入您的登入用戶名。",
            })}
            />
        </VStack>
        <VStack fullWidth>
          <HStack HAlign="[" spacing={5}>
            <XText fontSize={12} color={ColorX.CSS("Stone")}>
              {LocaleX.Parse({
                EN: "Password",
                TC: "密碼"
              })}
            </XText>
            <XText fontSize={12} color={ColorX.CSS("Blood")}>
              {"*"}
            </XText>
          </HStack>
          <QFPassword
            name="password"
            fontSize={14}
            p={12}
            bColor={ColorX.CSS("NotQuiteWhite")}
            placeholder={LocaleX.Parse({
              EN: "Please enter your password here.",
              TC: "請在此輸入您的密碼。",
            })}
            />
          <HStack HAlign="]">
            <XButton padding={3} onPress={this._toForgotPassword}>
              <HStack>
                <XText fontSize={12} decoration="underline">
                  {LocaleX.Parse({
                    EN: "Forgot Password?",
                    TC: "忘記密碼?"
                  })}
                </XText>
              </HStack>
            </XButton>
          </HStack>
        </VStack>
        <HStack HAlign="[">
        <ReCAPTCHA sitekey={APIKeys.reCAPTCHA} onChange={this._onReCaptchaChange}/>
        </HStack>
        <XButton {...Styles.QFBtn} fullWidth
          onPress={this._login} disabled={!epFormValid}>
          <HStack>
            <XText bold>
              {LocaleX.Parse({
                EN: "Sign In",
                TC: "登入"
              })}
            </XText>
          </HStack>
        </XButton>
        {!_.isEmpty(error)
          && 
          <XText color={ColorX.CSS("Blood")} fontSize={12} textAlign="[" fullWidth>
            {"*" + LocaleX.Parse(error)}
          </XText>
        }
        {this.renderRegisterLink()}
      </QForm>
    );
  }

  renderRegisterLink(){
    return (
      <HStack spacing={5} HAlign="[">
        <XText color={ColorX.CSS("pureWhite")} fontSize={12}>
          {LocaleX.Parse({
            EN: "Don't have an account?",
            TC: "沒有帳號?"
          })}
        </XText>
        <XButton notInjectColor onPress={this._toRegister} padding={0}>
          <HStack>
            <XText color={ColorX.CSS("blue")} decoration="underline" fontSize={12}>
              {LocaleX.Parse({
                EN: "Register",
                TC: "申請"
              })}
            </XText>
          </HStack>
        </XButton>
      </HStack>
    );
  }

  renderOTP(){
    let {canResend, OTPFormID} = this.state;
    return (
      <QForm spacing={24} fullHeight VAlign="-" pB={120} onMounted={this.onMountQFOTP} key={OTPFormID}>
        <VStack>
          <XText fontSize={32} color={ColorX.CSS("pureWhite")} bold>
            {LocaleX.Parse({
              EN: "Verify Your Account",
              TC: "驗證您的帳戶"
            })}
          </XText>
          <XText fontSize={14} color={ColorX.CSS("pureWhite")}>
            {LocaleX.Parse({
              EN: "Enter the 6-digit verification code sent to your registered email address",
              TC: "輸入發送到您註冊電子郵件地址的 6 位驗證碼"
            })}
          </XText>
        </VStack>
        <QFDigitBox onDigitEnd={this._autoVerifyOTP} 
          digit={6} name="otp"
          color={ColorX.CSS("Stone")}
          fontSize={30}
          p={12}
          bColor={ColorX.CSS("NotQuiteWhite")}/>
        <VStack>
          <XText fontSize={14} color={ColorX.CSS("pureWhite")}>
            {LocaleX.Parse({
              EN: "Didn't receive one-time code?",
              TC: "沒有收到一次性代碼？"
            })}
          </XText>
          <XButton onPress={this._resendOTP} disabled={!canResend}>
            <HStack>
              <XText color={ColorX.CSS("DeepBlueSea")} fontSize={16} bold>
                {LocaleX.Parse({
                  EN: "Resend",
                  TC: "重發"
                })}
              </XText>
              {!canResend && 
                <HStack fitWidthToContent>
                  <XText>{"("}</XText>
                  <CountDownLite onMounted={this.onMountCountDown}
                    countDown={60} onTimeUp={this._canResend}/>
                  <XText>{")"}</XText>
                </HStack>}
            </HStack>
          </XButton>
        </VStack>
      </QForm>
    );
  }

  renderStep(){
    let {step} = this.state;
    switch(step){
      default: 
      case "emailPassword": return this.renderEmailPassword();
      case "OTP": return this.renderOTP();
    }
  }

  render(){
    return (
      <VStack flexGrow={1} bgColor={ColorX.CSS("Grass")} fullWidth fullHeight>
        <XImage source="/Images/static/pattern.png" noResize maxWidth={"50%"} height={"auto"}
          position="absolute" style={{bottom: 0, right: 0}} zIndex={0}/>
        {this.renderStep()}
        {ResponsiveX.Split({0: () => <FooterM/>, [SysConfig.WebUIWidth]: () => null})}
      </VStack>
    );
  }

}

export default withRouter(observer(PLogin));
